import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  Stack,
  Backdrop,
  CircularProgress,
  Alert,
  IconButton,
  AlertTitle,
  Collapse,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTimeFilled';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CloseIcon from '@mui/icons-material/Close';
import sendEmail from '../../network/send_email';

const GetInTouchBlock = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);

  const isFormValid = name !== '' && email !== '' && message !== '';

  const handleSubmit = async () => {
    const formData = { name, email, message };

    try {
      setLoading(true);
      const response = await sendEmail(formData);
      if (response.ok)
        setAlert({
          type: 'success',
          message:
            'Email has been sent successfully! We will contact you soon.',
        });
      else
        setAlert({
          type: 'error',
          message:
            'Failed to send email. Please try again or contact us via phone.',
        });

      const data = await response.json();
    } catch (error) {
      console.error('Error:', error);
      setAlert({
        type: 'error',
        message:
          'Unexpected Error. Failed to send email. Please try again or contact us via phone.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 8 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: 'bold' }}
      >
        Get in touch
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <Typography>
              Complete the below form and we will get back to you as soon as
              possible.
            </Typography>
            <TextField
              label="Your name"
              variant="outlined"
              required
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              label="Your e-mail"
              variant="outlined"
              required
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label="Your phone number (Optional)"
              variant="outlined"
              fullWidth
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <TextField
              label="Your message"
              variant="outlined"
              required
              fullWidth
              multiline
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={!isFormValid}
            >
              Submit
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2} sx={{ textAlign: 'left', mt: 2 }}>
            <Grid item xs={6} md={6}>
              <Stack spacing={8}>
                <Box>
                  <Typography variant="h5">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <LocationOnIcon
                        sx={{ mr: 1 }}
                        fontSize="large"
                        color="primary"
                      />
                      Address
                    </Box>
                  </Typography>
                  <Typography sx={{ ml: 5.5 }} color="textSecondary">
                    <span>Flat 5</span>
                    <br />
                    <span>93 Station Road</span>
                    <br />
                    <span>Redhill</span>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="h5">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <AccessTimeIcon
                        sx={{ mr: 1 }}
                        fontSize="large"
                        color="primary"
                      />
                      Office Hours
                    </Box>
                  </Typography>
                  <Typography sx={{ ml: 5.5 }} color="textSecondary">
                    <span>Monday - Friday</span>
                    <br />
                    <span>9am to 6pm</span>
                    <br />
                  </Typography>
                </Box>
              </Stack>
            </Grid>
            {/* <Grid item xs={12} md={3}></Grid> */}
            <Grid item xs={6} md={6}>
              <Stack spacing={10}>
                <Box>
                  <Typography variant="h5">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <PhoneIcon
                        sx={{ mr: 1 }}
                        fontSize="large"
                        color="primary"
                      />
                      Phone
                    </Box>
                  </Typography>
                  <Typography sx={{ ml: 5.5 }} color="textSecondary">
                    <span>Number 1</span>
                    <br />
                    <span>Number 2</span>
                    <br />
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="h5">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1,
                      }}
                    >
                      <EmailIcon
                        sx={{ mr: 1 }}
                        fontSize="large"
                        color="primary"
                      />
                      Email
                    </Box>
                  </Typography>
                  <Typography sx={{ ml: 5.5 }} color="textSecondary">
                    <span>formation.uk.company@gmail.com</span>
                    <br />
                  </Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Backdrop open={loading} style={{ zIndex: 9999, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Collapse in={alert !== null}>
        {alert && (
          <Alert
            severity={alert.type}
            variant="filled"
            sx={{ mt: 2, ml: 12, mr: 12 }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => setAlert(null)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle align="left">
              {alert.type === 'success' ? 'Success' : 'Error'}
            </AlertTitle>
            {alert.message}
          </Alert>
        )}
      </Collapse>
    </Box>
  );
};

export default GetInTouchBlock;
